import React from 'react';
// @ts-ignore
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { initializeCapacitor, isNativePlatform } from './capacitor';

const container = document.getElementById('root');
if (container) {
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );

  // Initialize Capacitor after app renders
  initializeCapacitor();
}

// Only register service worker for web, not native apps
if (!isNativePlatform) {
  serviceWorkerRegistration.unregister();
}

